import api from './axios';

export const listar    = ()          => api.get('/tipos-uniforme/');
export const criar     = (data)      => api.post('/tipos-uniforme/', data);
export const atualizar = (id, data)  => api.patch(`/tipos-uniforme/${id}`, data);
